exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".project.complete[data-v-4ef9eba0]{border-left:4px solid #039be5}.project.ongoing[data-v-4ef9eba0]{border-left:4px solid orange}.project.overdue[data-v-4ef9eba0]{border-left:4px solid tomato}.ciro-analiz-report-table[data-v-4ef9eba0]{width:100%;margin-top:4px}.ciro-analiz-report-table>*[data-v-4ef9eba0]{width:100%}", ""]);

// exports
